import { createContext } from 'react'

import type { StompConnection } from '@/lib/ws/stompClient'

export const StompContext = createContext<StompConnection | null>(null)
